import { useState, useCallback } from 'react';
import { UploadProgress } from '../../../../../../../services/signalRService';

/**
 * Hook for managing carve-out upload progress state
 */
export function useCarveOutUpload() {
  const [uploadProgress, setUploadProgress] = useState<UploadProgress | null>(null);
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);

  const onProgress = useCallback((progress: UploadProgress) => {
    setUploadProgress(progress);
  }, []);

  const onCompleted = useCallback((progress: UploadProgress) => {
    setUploadProgress(progress);
    setIsUploadInProgress(false);
  }, []);

  const onError = useCallback((progress: UploadProgress) => {
    setUploadProgress(progress);
    setIsUploadInProgress(false);
  }, []);

  const handleCloseProgressDialog = useCallback(() => {
    setUploadProgress(null);
    setIsUploadInProgress(false);
  }, []);

  const handleStartUpload = useCallback(() => {
    setIsUploadInProgress(true);
  }, []);

  return {
    uploadProgress,
    isUploadInProgress,
    onProgress,
    onCompleted,
    onError,
    handleCloseProgressDialog,
    handleStartUpload,
  };
}
